import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=a452e946&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=a452e946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a452e946",
  null
  
)

export default component.exports